module.exports = __webpack_public_path__ + "img/Sanders One Stop Solution.8a4239e5.png";